import { SHIFT_STATUSES } from '@/shared/constants/shifts'
import campaignCreator from './campaign-creator'

// SHIFT
const objToKeyValueStrs = obj => Object.keys(obj).map(key => `${key}: ${obj[key]}`) // TODO moved to hw-core

const extractNewUpdates = (updateStates, shiftId) => {
  const foundUpdate = updateStates.find(update => update.id === shiftId)
  return foundUpdate ? { date: new Date(), state: foundUpdate.state, processer: foundUpdate.processer, content: objToKeyValueStrs(foundUpdate.content) } : []
}

const augmentShift = (shift, { areaInfo, boostStatus, updateStates }) => {
  const {accountId, sectionInfo, areaId, contractId, salary } = areaInfo
  return {
    ...shift,
    finalConfirmation: { sent: false, confirmed: false },
    requirements: shift.roleType ? Array.from(new Set([...shift.requirements, shift.roleType])) : [],
    updates: (shift.updates || []).concat(extractNewUpdates(updateStates, shift.id)),
    title: shift.title ? shift.title : sectionInfo,
    accountId,
    areaId,
    contractId,
    salary,
    ...(shift.status === SHIFT_STATUSES.open ? boostStatus : {})
  }
}

// SHIFTS
const augmentShifts = (inputShifts, { areaInfo, boostStatus, updateStates }) => 
inputShifts.reduce((acc, shift) => {
    acc.shifts.push(augmentShift(shift, { areaInfo, boostStatus, updateStates} ))
    if(shift.status === SHIFT_STATUSES.open || shift.status === SHIFT_STATUSES.draft){ acc.stats.noOfAvailableShifts +=1 }
    if (!acc.stats.range.start || acc.stats.range.start > shift.start) { acc.stats.range.start = shift.start } // find the earliest start, and latest start
    if (!acc.stats.range.end || shift.start > acc.stats.range.end) { acc.stats.range.end = shift.start }
    acc.stats.tags = [...new Set([...acc.stats.tags,...shift.requirements, shift.roleType])]
    return acc
  }, {shifts: [], stats: {noOfAvailableShifts: 0, range: {}, tags: []}})

const addCampaignsToShifts = async (shifts, { areaInfo, range }) => {
  const {accountId, areaId} = areaInfo
  await campaignCreator.init(accountId, areaId, range)
  const shiftsWithCampaigns = await Promise.all(shifts.map(async shift => {
    const { campaignId, campaignDetails } = await campaignCreator.createCampaign(shift.start, shift.end)
    return {...shift, campaignId, campaignDetails }
  }))
  return shiftsWithCampaigns.reduce((acc, shift) => {
    const {campaignId, campaignDetails} = shift
    acc.stats.campaigns = acc.stats.campaigns.concat(campaignId ? [{campaignId, campaignDetails}] : [])
    acc.shifts.push({...shift, campaignDetails: campaignId ? {price: campaignDetails.price, salary: campaignDetails.salary} : {}})
    return acc
  }, {shifts: [], stats: {campaigns: []}})
}

const transformShifts = async (inputShifts, {areaInfo, boostStatus, updateStates}) => {
  const augmentShiftsRes = augmentShifts(inputShifts, {areaInfo, boostStatus, updateStates})
  const addCampaignsToShiftsRes = await addCampaignsToShifts(augmentShiftsRes.shifts, {areaInfo, range: augmentShiftsRes.stats.range})
  return {shifts: addCampaignsToShiftsRes.shifts, stats: {...augmentShiftsRes.stats, ...addCampaignsToShiftsRes.stats, totalShifts: addCampaignsToShiftsRes.shifts.length}}
}

const shiftsCreator = { transformShifts }

export default shiftsCreator